<!--
  File: UserCoupon.vue
-->

<template>
  <v-container fluid>
    <v-row>
      <v-col sm="12" md="6" :class="{'pa-0': $vuetify.breakpoint.smAndDown}">
        <v-card outlined>
          <v-toolbar class="elevation-0" color="background">
            <v-toolbar-title>회원 쿠폰 관리</v-toolbar-title>
          </v-toolbar>
          <v-row class="pa-3" align="center">
            <v-col cols="4"><v-select class="font-13" v-model="expire" :items="expires" label="유효기간" @change="getCouponUser()"/></v-col>
            <v-col cols="3"><v-select class="font-13" v-model="remain" :items="remains" label="남은쿠폰" @change="getCouponUser()" /></v-col>
            <v-col cols="3"><v-text-field class="font-13" v-model="keyword" label="성명" @keyup.13.stop.prevent="search()" /></v-col>
            <v-col cols="2" md="1"><v-icon @click="search()">mdi-magnify</v-icon></v-col>
            <v-col cols="1" v-if="$vuetify.breakpoint.mdAndUp"><v-icon @click="refresh()">mdi-refresh</v-icon></v-col>
          </v-row>
          <v-row style="margin-bottom: -40px" />
          <v-row class="pl-3 pr-3">
            <v-col cols="6" class="pl-11">회원명 (아이디)</v-col>
            <v-col cols="3" v-if="$vuetify.breakpoint.mdAndUp">유효기간</v-col>
            <v-col cols="2" v-if="$vuetify.breakpoint.mdAndUp">남은갯수</v-col>
            <v-col cols="5" v-if="$vuetify.breakpoint.smAndDown">남은기간<span class="pa-1" />남은갯수</v-col>
          </v-row>
          <v-row class="pl-3 pr-3" >
            <v-divider />
          </v-row>
          <v-row v-if="items() == 0" class="pa-3">
            <v-col cols="12" class="mb-3 text-center">조건에 해당되는 내용이 없습니다.</v-col>
          </v-row>
          <v-row class="pl-3 pr-3" v-for="(item, i) in pages[page - 1]" :key="i" align="center">
            <v-col cols="6" class="pl-3 pb-0 mt--15 mb--10">
              <v-checkbox
                class="pa-0 text-truncate"
                v-model="item.checked" :label="item.name + ' (' + item.email + ')'"
                @change="checks()"
              />
            </v-col>
            <v-col cols="3" v-if="$vuetify.breakpoint.mdAndUp" class="text-truncate warning--text font-weight-bold">
              {{util.getDate(new Date(item.expired))}}
            </v-col>
            <v-col cols="2" v-if="$vuetify.breakpoint.smAndDown" class="warning--text font-weight-bold">{{item.days}}일</v-col>
            <v-col cols="2" class="text-truncate warning--text font-weight-bold">{{item.remain}}</v-col>
            <v-col cols="2" md="1"><v-icon @click="getCoupons(item)">mdi-arrow-right-thin-circle-outline</v-icon></v-col>
          </v-row>
          <v-row v-if="pages.length == 1" class="pa-3" />
          <v-row v-if="pages.length > 1" class="pa-3">
            <v-divider />
          </v-row>
          <v-row v-if="pages.length > 1" class="ma-3" justify="center">
            <v-pagination v-model="page" :length="pages.length" @input="move()"/>
          </v-row>
        </v-card>
        <v-row v-if="items()" class="pa-3" align="center">
          <v-col cols="8" class="pa-3">
            <v-row align="center">
              <v-checkbox class="pl-3 pr-3" v-model="checked" label="전체선택" @click="checkAll()"/>
              <v-btn class="elevation-0" color="primary" @click="sendText()" v-if="checks()">문자보내기</v-btn>
            </v-row>
          </v-col>
          <v-col cols="4" class="text-right font-weight-bold">{{checks()}} / {{items()}}</v-col>
        </v-row>
      </v-col>
      
      <v-col sm="12" md="6" v-if="coupons" :class="{'pa-0': $vuetify.breakpoint.smAndDown}">
        <v-card outlined>
          <v-toolbar class="mb-3 elevation-0" color="background">
            <v-toolbar-title>{{user.name}} ({{user.email}})님의 쿠폰 정보</v-toolbar-title>
          </v-toolbar>
          <v-row class="ma-1">
            <v-col cols="3" md="2">쿠폰명</v-col>
            <v-col cols="3" v-if="$vuetify.breakpoint.mdAndUp">발행일</v-col>
            <v-col cols="3" v-if="$vuetify.breakpoint.mdAndUp">유효기간</v-col>
            <v-col cols="3" v-if="$vuetify.breakpoint.smAndDown">남은기간</v-col>
            <v-col cols="3" md="2">발행갯수</v-col>
            <v-col cols="3" md="2">남은갯수</v-col>
          </v-row>
          <v-divider />
          <v-row :class="'ma-1 ' + color(coupon)" v-for="(coupon, i) in coupons" :key="i">
            <v-col cols="3" md="2">{{coupon.name}}</v-col>
            <v-col cols="3" v-if="$vuetify.breakpoint.mdAndUp">{{util.getDate(new Date(coupon.cdate))}}</v-col>
            <v-col cols="3" v-if="$vuetify.breakpoint.mdAndUp">{{util.getDate(new Date(coupon.expired))}}</v-col>
            <v-col cols="3" v-if="$vuetify.breakpoint.smAndDown && coupon.days < 0">만료</v-col>
            <v-col cols="3" v-if="$vuetify.breakpoint.smAndDown && coupon.days >= 0">{{coupon.days}}일</v-col>
            <v-col cols="3" md="2">{{coupon.total}}</v-col>
            <v-col cols="3" md="2">{{coupon.remain}}</v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios'
import util from '../utils/util'

export default {
  data () {
    return {
      login: null,
      edit: null,
      expire: null,
      remain: null,
      expires: [
        { value: 180, text: '6개월' },
        { value: 90, text: '3개월' },
        { value: 30, text: '1개월' },
        { value: 7, text: '1주일' },
        { value: 3, text: '3일' }
      ],
      remains: [
        { value: 30, text: '30개' },
        { value: 20, text: '20개' },
        { value: 10, text: '10개' },
        { value: 5, text: '5개' },
        { value: 0, text: '없음' }
      ],
      page: 1,
      pages: [],
      keyword: '',
      coupons: null,
      checked: false,
      user: {},
      util: util
    }
  },

  props: {
    source: String,
  },

  methods: {
    color: function(item) {
      return item.days < 0 || item.remain == 0 ? 'grey--text' : 'primary--text'
    },

    move: function () {
      this.coupons = null

      if (this.items() == 0) return 0
      this.pages[this.page - 1].forEach(item => {
        this.checked = item.checked
      })
    },

    search: function () {
      if (this.keyword.trim().length < 1) {
        alert('찾는 분의 이름를 입력하세요.')
        return
      }
      this.expire = null
      this.remain = null
      let url = `/api/coupon/user/${this.login.studio}/${this.keyword}`
      this.fetch(url)
    },

    refresh: function () {
      this.expire = 30
      this.remain = 10
      
      this.getCouponUser()
    },

    getCouponUser: function () {
      if (this.expire == null) { this.expire = 30 }
      if (this.remain == null) { this.remain = 10 }
      
      let url = `/api/coupon/user/${this.login.studio}/${this.expire}/${this.remain}`
      this.fetch(url)
    },

    fetch: function (url) {
      console.log(url)
      this.user = {}
      axios.get(url, util.headers)
      .then(response => {
        if (response.data.error)
          console.log(response.data.error)
        else {
          this.pages.forEach(users => {
            users.splice(0, users.length)
          })
          this.pages.splice(0, this.pages.length)
          this.users = response.data.list.length
          for (let i = 0; i < this.users; i += 10) {
            this.pages.push(response.data.list.slice(i, i + 10))
          }
          this.page = 1
          this.move()
        }
      })
    },

    items: function () {
      if (this.pages.length == 0) return 0
      return (this.pages.length - 1) * 10 + this.pages[this.pages.length - 1].length
    },
    
    getCoupons: function (item) {
      this.user = item
      axios.get(`/api/coupon/user/${this.user.id}`)
      .then(response => {
        if (response.data.error)
          console.log(response.data.error)
        else {
          this.coupons = response.data.coupons
        }
      })
    },

    checkAll: function () {
      this.pages[this.page - 1].forEach(item => {
        item.checked = this.checked
      })
    },

    checks: function () {
      let count = 0
      this.pages.forEach(items => {
        items.forEach(item => {
          count += (item.checked ? 1 : 0)
        })
      })
      return count
    },

    sendText: function () {
      let mobiles = []
      this.pages.forEach(items => {
        items.forEach(item => {
          if (item.checked) mobiles.push(util.getPhoneNumber(item.mobile))
        })
      })
      location.href='sms:/ ' + mobiles.join(',')
    }
  },

  created () {
    console.clear()
    let json = localStorage.getItem('login')
    if (json) {
      this.login = JSON.parse(json)
    }
    if (this.login) {
      this.$emit('login', this.login)

      this.refresh()
    }
    else {
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.mt--5 {
  margin-top: -5px;
}
.mt--15 {
  margin-top: -15px;
}
.mb--10 {
  margin-bottom: -10px;
}
.font-13 {
  font-size: 13px;
}
</style>